export function decodeBase64ToUtf8(b64: string): string {
    // handles UTF-8
    const bin = atob(b64);
    const bytes = Uint8Array.from(bin, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}

export function encodeUtf8ToBase64(s: string): string {
    const bytes = new TextEncoder().encode(s);
    let bin = "";
    bytes.forEach(b => (bin += String.fromCharCode(b)));
    return btoa(bin);
}